/** Internal dependencies */
import { loadingSpinner, loadmoreSpinner } from "./spinners";
import { updateItems } from "./updateItems";
import { deleteItems, finish, prepareUrl } from "./utilities";

export function apiCall(parent, apiFilter, reset, loadmoreClick = false) {
  const api = JSON.parse(parent.dataset.rest);
  const restUrl = prepareUrl(api.endpoint, api);
  const loadMoreLimit = 6;
  const error = parent.querySelector("[data-error]");
  const notFound = parent.querySelector("[data-notfound]");
  const btnLoadMore = parent.querySelector("[data-loadmore]");
  const noMoreEntries = parent.querySelector(".no-more-entries");
  const nonce = document.body.dataset.restNonce;
  const itemsContainer = parent.querySelector("[data-items]");

  jQuery(noMoreEntries).hide();

  const fetchOptions = {};
  if (nonce && nonce.length) {
    const headers = new Headers();
    headers.append("X-WP-Nonce", nonce);
    fetchOptions.headers = headers;
  }

  if (reset) {
    loadingSpinner(parent);
  } else {
    loadmoreSpinner(parent);
  }

  fetch(`${restUrl}?${apiFilter}`, fetchOptions)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const contentType = response.headers.get("content-type");
      if (!contentType || !contentType.includes("application/json")) {
        throw new TypeError("Oops, we haven't got JSON!");
      }

      return response.json();
    })
    .then((result) => {
      if (reset) {
        deleteItems(itemsContainer);
      }

      const isArray = Array.isArray(result.data);

      error.classList.add("d-none");
      notFound.classList.add("d-none");

      if (result.data && result.data === null) {
        if (loadmoreClick === true) {
          jQuery(noMoreEntries).show();
        } else {
          notFound.classList.remove("d-none");
        }

        btnLoadMore.classList.add("d-none");
      }

      if (isArray) {
        updateItems(parent, result);

        if (result.data && result.data.length <= 0) {
          notFound.classList.remove("d-none");
        }

        if (
          result.data &&
          (result.total <= loadMoreLimit ||
            parseInt(result.offset) + result.data.length >= result.total)
        ) {
          btnLoadMore.classList.add("d-none");
        } else {
          btnLoadMore.classList.remove("d-none");
        }
      } else {
        if (result.offset === "0") {
          notFound.classList.remove("d-none");
          finish(parent);
        }

        btnLoadMore.classList.add("d-none");
        return;
      }

      if (result.currentpage >= result.totalpages) {
        finish(parent);
      } else {
        jQuery(btnLoadMore).show();
      }
    })
    .catch((errorMsg) => {
      error.classList.remove("d-none");
      console.error(
        "There has been a problem with your fetch operation:",
        errorMsg
      );
    })
    .finally(() => {
      if (reset) {
        loadingSpinner(parent, false);
      } else {
        loadmoreSpinner(parent, false);
      }
    });
}
